/**
 * Track Record Partner Popup
 * Opens modal on click on .track-record-point__image with partner ACF + taxonomy data.
 * Blue theme for standard companies, orange for unicorns.
 */
(function() {
	'use strict';

	const popup = document.getElementById('track-record-partner-popup');
	if (!popup) {
		return;
	}

	const overlay = popup.querySelector('.track-record-popup__overlay');
	const closeButtons = popup.querySelectorAll('[data-track-record-popup-close]');
	const contentEl = popup.querySelector('.track-record-popup__content');

	// Content elements
	const titleEl = document.getElementById('track-record-popup-title');
	const statusEl = document.getElementById('track-record-popup-status');
	const startingStageRow = document.getElementById('track-record-popup-starting-stage');
	const startingStageValue = document.getElementById('track-record-popup-starting-stage-value');
	const geographicReachRow = document.getElementById('track-record-popup-geographic-reach');
	const geographicReachValue = document.getElementById('track-record-popup-geographic-reach-value');
	const recruitmentModelsRow = document.getElementById('track-record-popup-recruitment-models');
	const recruitmentModelsList = document.getElementById('track-record-popup-recruitment-models-list');
	const timeToFillRow = document.getElementById('track-record-popup-time-to-fill');
	const timeToFillValue = document.getElementById('track-record-popup-time-to-fill-value');
	const medianEl = document.getElementById('track-record-popup-median');
	const medianValueEl = document.getElementById('track-record-popup-median-value');
	const medianBracketOpen = document.getElementById('track-record-popup-median-bracket-open');
	const medianBracketClose = document.getElementById('track-record-popup-median-bracket-close');
	const partnershipSincRow = document.getElementById('track-record-popup-partnership-sinc');
	const partnershipSincValue = document.getElementById('track-record-popup-partnership-sinc-value');
	const leadershipHiresRow = document.getElementById('track-record-popup-leadership-hires');
	const leadershipHiresValue = document.getElementById('track-record-popup-leadership-hires-value');
	const featuresBlock = document.getElementById('track-record-popup-features');
	const featuresList = document.getElementById('track-record-popup-features-list');
	const featuresTitleEl = document.getElementById('track-record-popup-features-title');

	const UNICORN_CLASS = 'track-record-popup--unicorn';
	const OPEN_CLASS = 'is-open';

	function setVisibility(el, visible) {
		if (!el) return;
		if (visible) {
			el.removeAttribute('hidden');
		} else {
			el.setAttribute('hidden', '');
		}
	}

	function openModal(data) {
		if (!data) return;

		if (typeof data === 'string') {
			try {
				data = JSON.parse(data);
			} catch (e) {
				console.error('Track record popup: invalid JSON', e);
				return;
			}
		}

		// Theme: unicorn = orange, else blue
		if (data.is_unicorn) {
			popup.classList.add(UNICORN_CLASS);
		} else {
			popup.classList.remove(UNICORN_CLASS);
		}

		// Title
		if (titleEl) {
			titleEl.textContent = data.title || '';
		}

		// Status pill
		if (statusEl) {
			if (data.status && String(data.status).trim()) {
				statusEl.textContent = data.status;
				setVisibility(statusEl, true);
			} else {
				setVisibility(statusEl, false);
			}
		}

		// Starting stage
		if (startingStageRow && startingStageValue) {
			if (data.starting_stage && String(data.starting_stage).trim()) {
				startingStageValue.textContent = data.starting_stage;
				setVisibility(startingStageRow, true);
			} else {
				setVisibility(startingStageRow, false);
			}
		}

		// Geographic reach
		if (geographicReachRow && geographicReachValue) {
			if (data.geographic_reach && String(data.geographic_reach).trim()) {
				geographicReachValue.textContent = data.geographic_reach;
				setVisibility(geographicReachRow, true);
			} else {
				setVisibility(geographicReachRow, false);
			}
		}

		// Recruitment models (pills)
		if (recruitmentModelsRow && recruitmentModelsList) {
			if (data.recruitment_models && Array.isArray(data.recruitment_models) && data.recruitment_models.length > 0) {
				recruitmentModelsList.innerHTML = '';
				data.recruitment_models.forEach(function(name) {
					const pill = document.createElement('span');
					pill.className = 'track-record-popup__pill';
					pill.textContent = name;
					recruitmentModelsList.appendChild(pill);
				});
				setVisibility(recruitmentModelsRow, true);
			} else {
				setVisibility(recruitmentModelsRow, false);
			}
		}

		// Average time to fill (average in value, median: label from PHP, value in #track-record-popup-median-value)
		if (timeToFillRow && timeToFillValue) {
			const avg = data.average_time_to_fill && String(data.average_time_to_fill).trim();
			const median = data.median && String(data.median).trim();
			if (avg || median) {
				timeToFillValue.textContent = avg || '';
				if (medianEl) {
					if (median) {
						if (medianValueEl) {
							medianValueEl.textContent = median;
						}
						setVisibility(medianBracketOpen, !!avg);
						setVisibility(medianBracketClose, !!avg);
						setVisibility(medianEl, true);
					} else {
						if (medianValueEl) {
							medianValueEl.textContent = '';
						}
						setVisibility(medianEl, false);
						setVisibility(medianBracketOpen, false);
						setVisibility(medianBracketClose, false);
					}
				}
				setVisibility(timeToFillRow, true);
			} else {
				setVisibility(timeToFillRow, false);
				if (medianEl) {
					setVisibility(medianEl, false);
					setVisibility(medianBracketOpen, false);
					setVisibility(medianBracketClose, false);
				}
			}
		}

		// Partnership since
		if (partnershipSincRow && partnershipSincValue) {
			if (data.partnership_sinc && String(data.partnership_sinc).trim()) {
				partnershipSincValue.textContent = data.partnership_sinc;
				setVisibility(partnershipSincRow, true);
			} else {
				setVisibility(partnershipSincRow, false);
			}
		}

		// Leadership hires
		if (leadershipHiresRow && leadershipHiresValue) {
			if (data.leadership_hires && String(data.leadership_hires).trim()) {
				leadershipHiresValue.textContent = data.leadership_hires;
				setVisibility(leadershipHiresRow, true);
			} else {
				setVisibility(leadershipHiresRow, false);
			}
		}

		// Features list
		if (featuresBlock && featuresList) {
			if (data.features && Array.isArray(data.features) && data.features.length > 0) {
				if (featuresTitleEl) {
					featuresTitleEl.textContent = data.features_title || '';
				}
				featuresList.innerHTML = '';
				data.features.forEach(function(feature) {
					const li = document.createElement('li');
					li.className = 'track-record-popup__features-item';
					li.textContent = feature;
					featuresList.appendChild(li);
				});
				setVisibility(featuresBlock, true);
			} else {
				setVisibility(featuresBlock, false);
			}
		}

		popup.classList.add(OPEN_CLASS);
		document.body.style.overflow = 'hidden';
	}

	function closeModal() {
		popup.classList.remove(OPEN_CLASS);
		popup.classList.remove(UNICORN_CLASS);
		document.body.style.overflow = '';
	}

	// Delegate click: .track-record-point__image or .track-record-point
	const section = document.getElementById('track-record-section');
	if (section) {
		section.addEventListener('click', function(e) {
			const imageEl = e.target.closest('.track-record-point__image');
			const pointEl = e.target.closest('.track-record-point');
			if (!imageEl || !pointEl) return;

			e.preventDefault();
			e.stopPropagation();

			const json = pointEl.getAttribute('data-track-record-popup');
			if (json) {
				openModal(json);
			}
		});
	}

	closeButtons.forEach(function(btn) {
		btn.addEventListener('click', function(e) {
			e.preventDefault();
			closeModal();
		});
	});

	if (overlay) {
		overlay.addEventListener('click', function(e) {
			e.preventDefault();
			closeModal();
		});
	}

	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && popup.classList.contains(OPEN_CLASS)) {
			closeModal();
		}
	});
})();
